import React, { useEffect, useState, useCallback } from "react";
import { Helmet } from "react-helmet";

import { faMailBulk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";

import Works from "../components/homepage/works";
import AllProjects from "../components/projects/allProjects";
import PixelDivider from "../components/pixel/PixelDivider";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/homepage.css";

const Homepage = () => {
	const [emailCopied, setEmailCopied] = useState(false);

	const handleEmailCopy = useCallback(() => {
		navigator.clipboard.writeText(INFO.main.email).then(() => {
			setEmailCopied(true);
			setTimeout(() => setEmailCopied(false), 2000);
		});
	}, []);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "home");

	return (
		<>
			<Helmet>
				<title>{INFO.main.title}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<div className="content-wrapper">
					<div className="homepage-container">
						<div
							className="mono homepage-eyebrow"
							data-reveal
						>
							● PORTFOLIO · KEEFE.O · 2026
						</div>
						<div className="homepage-first-area">
							<div className="homepage-first-area-left-side">
								<div
									className="title homepage-title"
									data-reveal
								>
									{INFO.homepage.title}
								</div>

								<div
									className="subtitle homepage-subtitle"
									data-reveal
								>
									{INFO.homepage.description}
								</div>
								<div
									className="subtitle homepage-subtitle"
									data-reveal
								>
									If you have a specific question or comment,
									please feel free to email me directly
									at&nbsp;{""}
									{INFO.main.email}.
								</div>
							</div>

							<div
								className="homepage-first-area-right-side"
								data-reveal
							>
								<div className="viewfinder-wrap">
									<div className="viewfinder-body">
										<div className="viewfinder-screen">
											<img
												src="/headshot.jpg"
												alt="Keefe Oentoro"
												className="homepage-photo"
											/>

											{/* HUD top bar */}
											<div className="vf-hud-top">
												<span className="vf-focal">
													85
													<span className="vf-unit">
														mm
													</span>
												</span>
												<span className="vf-af">
													AF-S · FACE/EYE
												</span>
												<span className="vf-meter">
													⊙ M
												</span>
											</div>

											{/* Corner AF brackets */}
											<div className="vf-corner vf-tl" />
											<div className="vf-corner vf-tr" />
											<div className="vf-corner vf-bl" />
											<div className="vf-corner vf-br" />

											{/* Rule of thirds grid */}
											<div className="vf-grid" />

											{/* HUD bottom bar */}
											<div className="vf-hud-bottom">
												<div className="vf-ev-track">
													<span className="vf-ev-neg">
														−2
													</span>
													<div className="vf-ev-bar">
														<div className="vf-ev-pip" />
													</div>
													<span className="vf-ev-pos">
														+2
													</span>
												</div>
												<div className="vf-status">
													<span className="vf-mode">
														A
													</span>
													<span className="vf-batt">
														▐▐▐▌
													</span>
												</div>
											</div>

											{/* Vignette */}
											<div className="vf-vignette" />

											{/* Scanlines */}
											<div className="vf-scanlines" />
										</div>

										<div className="vf-footer">
											<span className="vf-footer-exp">
												f/1.8 · 1/200 · ISO 400
											</span>
											<span className="vf-footer-file">
												_DSC0847.ARW
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<PixelDivider />

						<div className="homepage-socials">
							<a
								href={INFO.socials.github}
								target="_blank"
								rel="noreferrer"
							>
								<FontAwesomeIcon
									icon={faGithub}
									className="homepage-social-icon"
								/>
							</a>
							<button
								className={`homepage-email-btn${emailCopied ? " homepage-email-btn--copied" : ""}`}
								onClick={handleEmailCopy}
								aria-label="Copy email address"
							>
								<FontAwesomeIcon
									icon={faMailBulk}
									className="homepage-social-icon"
								/>
								<span
									className={`homepage-email-toast${emailCopied ? " homepage-email-toast--visible" : ""}`}
								>
									Copied!
								</span>
							</button>
							<a
								href={INFO.socials.linkedin}
								target="_blank"
								rel="noreferrer"
							>
								<FontAwesomeIcon
									icon={faLinkedin}
									className="homepage-social-icon"
								/>
							</a>
						</div>
						<div className="homepage-projects">
							<AllProjects />
						</div>
						<div className="homepage-works">
							<Works />
						</div>

						{/* <div className="homepage-after-title"> */}
						{/* <div className="homepage-articles">
								{myArticles.map((article, index) => (
									<div
										className="homepage-article"
										key={(index + 1).toString()}
									>
										<Article
											key={(index + 1).toString()}
											date={article().date}
											title={article().title}
											description={article().description}
											link={"/article/" + (index + 1)}
										/>
									</div>
								))}
							</div> */}

						{/* <div className="homepage-articles">
							</div> */}
						{/* </div> */}
					</div>
				</div>
			</div>
		</>
	);
};

export default Homepage;
